import React from "react";
import { Calendar, Edit3, Trash2 } from "react-feather";
import EmptyState from "../../common/EmptyState";

// The "toy shelf" product grid shared by the products-by-category / brand /
// campaign pages (styles: .kd-shelf* in products-kido.css). Pages keep their
// own logic and pass it in as handlers; `onBrand` is optional because some
// pages show brands as plain labels.
const ProductShelf = ({
  products,
  checkedValues,
  selectAll,
  onToggleAll,
  onToggle,
  getPrice,
  onOpen,
  onCategory,
  onBrand,
  onDelete,
  emptyText,
}) => (
  <>
    <div className="kd-shelf-toolbar">
      <label className="kd-shelf-selectall">
        <input
          type="checkbox"
          className="kd-check"
          name="selectAll"
          checked={selectAll}
          onChange={onToggleAll}
        />
        Select all
      </label>
      <span className="kd-muted">
        {products.length} {products.length === 1 ? "product" : "products"}
      </span>
    </div>

    {products.length === 0 ? (
      <EmptyState>{emptyText}</EmptyState>
    ) : (
      <ul className="kd-shelf">
        {products.map((product, index) => {
          const isChecked = checkedValues.includes(product.id);
          const inStock = product.stockStatus === "In stock";
          return (
            <li
              key={product.id || index}
              className={"kd-shelf-card" + (isChecked ? " is-selected" : "")}
              style={{ "--i": Math.min(index, 12) }}
            >
              <div className="kd-shelf-media">
                <img
                  className="lazyloaded blur-up"
                  src={product.pictures && product.pictures[0]}
                  alt=""
                  onClick={() => onOpen(product)}
                />
                <label className="kd-shelf-check" title="Select">
                  <input
                    type="checkbox"
                    className="kd-check"
                    name={product.id}
                    checked={isChecked}
                    onChange={(e) => onToggle(e, product.id)}
                    aria-label={`Select ${product.name}`}
                  />
                </label>
                {product.published !== "Published" && (
                  <span className="kd-shelf-flag">{product.published}</span>
                )}
                <span className="kd-shelf-price">{getPrice(product)}</span>
              </div>

              <div className="kd-shelf-body">
                <button
                  type="button"
                  className="kd-shelf-name"
                  onClick={() => onOpen(product)}
                  title={product.name}
                >
                  {product.name}
                </button>

                <div className="kd-shelf-stock">
                  <span className={`kd-status-badge kd-st--${inStock ? "mint" : "rose"}`}>
                    <span className="kd-status-dot" />
                    {product.stockStatus}
                  </span>
                </div>

                {((product.selectedCategories || []).length > 0 ||
                  (product.selectedBrands || []).length > 0) && (
                  <div className="kd-shelf-chips">
                    {(product.selectedCategories || []).map((value, i) => (
                      <button
                        type="button"
                        key={`c-${value.id || i}`}
                        className="kd-chip-link kd-st--lilac"
                        onClick={() => onCategory(value)}
                      >
                        {value.name}
                      </button>
                    ))}
                    {(product.selectedBrands || []).map((brand, i) =>
                      onBrand ? (
                        <button
                          type="button"
                          key={`b-${brand.id || i}`}
                          className="kd-chip-link kd-st--sky"
                          onClick={() => onBrand(brand)}
                        >
                          {brand.name}
                        </button>
                      ) : (
                        <span key={`b-${brand.id || i}`} className="kd-chip-link kd-st--sky">
                          {brand.name}
                        </span>
                      )
                    )}
                  </div>
                )}

                {(product.selectedTags || []).length > 0 && (
                  <div className="kd-shelf-tags">
                    {product.selectedTags.map((value) => (
                      <span key={value}>#{value}</span>
                    ))}
                  </div>
                )}

                <div className="kd-shelf-date">
                  <Calendar size={12} aria-hidden="true" />
                  {product.edited ? "Modified" : "Published"} {product.publishedOn}
                </div>
              </div>

              <div className="kd-shelf-actions">
                <button
                  type="button"
                  className="kd-icon-btn kd-act--mint"
                  aria-label="Edit product"
                  title="Edit product"
                  onClick={() => onOpen(product)}
                >
                  <Edit3 size={14} aria-hidden="true" />
                </button>
                <button
                  type="button"
                  className="kd-icon-btn kd-act--rose"
                  aria-label="Delete product"
                  title="Delete product"
                  data-toggle="modal"
                  data-target="#deleteExpenseModal"
                  onClick={() => onDelete(product)}
                >
                  <Trash2 size={14} aria-hidden="true" />
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    )}
  </>
);

export default ProductShelf;
